import { Injectable } from '@angular/core';
import { CommonService } from './common.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DataService } from './data.service';
import { TranslateService } from '@ngx-translate/core';

import claimsMock from '@mocks/getClaims.json';
import claimsPastMock from '@mocks/getClaimsPast.json';
import { Claim } from '@shared/models/claim';
import { Correspondence } from '@shared/models/correspondence';
import { ClaimMyData } from 'app/models/claim-my-data';

@Injectable({
  providedIn: 'root'
})
export class ClaimService {
  private claims: Claim[];
  private claimsPast: Claim[];
  private documents: Correspondence[];

  constructor(
    private translateService: TranslateService,
    private commonService: CommonService,
    private dataService: DataService,
    private http: HttpClient
  ) {
    this.claims = claimsMock;
    this.claimsPast = claimsPastMock;
  }

  public getClaimsActive(): Observable<Claim[]> {
    if (this.commonService.useMocks) {
      return new Observable(observer => observer.next(this.claims));
    }

    return this.http.get<Claim[]>(this.commonService.getServiceUrl(`claim/active`));
  }

  public getClaimsPast(): Observable<Claim[]> {
    if (this.commonService.useMocks) {
      return new Observable(observer => observer.next(this.claimsPast));
    }

    return this.http.get<Claim[]>(this.commonService.getServiceUrl(`claim/past`));
  }

  public getMyClaimData(policyNumber: string, detailTypeIdentifier: string): Observable<ClaimMyData> {
    return this.http.get<ClaimMyData>(
      this.commonService.getServiceUrl(`claim/my-data/${encodeURIComponent(detailTypeIdentifier)}/${encodeURIComponent(policyNumber)}`)
    );
  }

  public postClaimData(claimMyData: ClaimMyData) {
    return this.http.post(claimMyData.destinationUrl, claimMyData.data);
  }
}
